const renderPost = ( post, idx, cats ) => {
    
    if(!post._embedded['wp:featuredmedia'][0]){ return null }

    const displayName = (init, matches) => {
        let names = [];
        init.map( post_cat => {
            matches.map( cat => {
                if(cat.term_id === post_cat) {
                    names.push(cat.name)
                }
            })
        })
        
        if(names.length > 0) {
            return (
                <div className={`blog-post__image-cat`}>
                    <span>{names[0]}</span>
                    {names[1] && (
                        <span>{names[1]}</span>
                    )}
                    {names[2] && (
                        <span>{names[2]}</span>
                    )}
                </div>
            )
        }
        return;
    }

    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const IEStyle = {
        backgroundImage: `url(${post._embedded['wp:featuredmedia'][0].source_url})`,
        backgroundPosition: `center`,
        backgroundSize: `cover`
    }

    return(
        <div key={ idx } className={`blog-post`}>
            <div className={`blog-post__image`} style={ isIE ? IEStyle : {}}>
                {displayName(post.categories, cats)}
                <a href={post.link}>
                    <img
                        style={ isIE ? {opacity: 0}: {}}
                        alt={post.title.rendered}
                        src={post._embedded['wp:featuredmedia'][0].source_url}
                    />
                </a>
            </div>
            <div className={`blog-post__title`}>
                <h2>{post.title.rendered}</h2>
                <a href={post.link}>Learn How</a>
            </div>
        </div>
    )
}

export default renderPost;